var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2004_259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15L15 9",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10C9.77614 10 10 9.77614 10 9.5C10 9.22386 9.77614 9 9.5 9C9.22386 9 9 9.22386 9 9.5C9 9.77614 9.22386 10 9.5 10Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15Z",
    fill: "#333333",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99655 7.20046C4.99655 6.61698 5.22834 6.05741 5.64092 5.64483C6.0535 5.23225 6.61308 5.00046 7.19655 5.00046H8.19655C8.77745 5.00013 9.33464 4.77006 9.74655 4.36046L10.4466 3.66046C10.651 3.45486 10.8941 3.2917 11.1618 3.18037C11.4295 3.06903 11.7166 3.01172 12.0066 3.01172C12.2965 3.01172 12.5836 3.06903 12.8513 3.18037C13.119 3.2917 13.3621 3.45486 13.5666 3.66046L14.2666 4.36046C14.6785 4.77006 15.2357 5.00013 15.8166 5.00046H16.8166C17.4 5.00046 17.9596 5.23225 18.3722 5.64483C18.7848 6.05741 19.0166 6.61698 19.0166 7.20046V8.20046C19.0169 8.78136 19.247 9.33855 19.6566 9.75046L20.3566 10.4505C20.5622 10.6549 20.7253 10.898 20.8366 11.1657C20.948 11.4334 21.0053 11.7205 21.0053 12.0105C21.0053 12.3004 20.948 12.5875 20.8366 12.8552C20.7253 13.1229 20.5622 13.366 20.3566 13.5705L19.6566 14.2705C19.247 14.6824 19.0169 15.2396 19.0166 15.8205V16.8205C19.0166 17.4039 18.7848 17.9635 18.3722 18.3761C17.9596 18.7887 17.4 19.0205 16.8166 19.0205H15.8166C15.2357 19.0208 14.6785 19.2509 14.2666 19.6605L13.5666 20.3605C13.3621 20.5661 13.119 20.7292 12.8513 20.8406C12.5836 20.9519 12.2965 21.0092 12.0066 21.0092C11.7166 21.0092 11.4295 20.9519 11.1618 20.8406C10.8941 20.7292 10.651 20.5661 10.4466 20.3605L9.74655 19.6605C9.33464 19.2509 8.77745 19.0208 8.19655 19.0205H7.19655C6.61308 19.0205 6.0535 18.7887 5.64092 18.3761C5.22834 17.9635 4.99655 17.4039 4.99655 16.8205V15.8205C4.99622 15.2396 4.76616 14.6824 4.35655 14.2705L3.65655 13.5705C3.45096 13.366 3.2878 13.1229 3.17646 12.8552C3.06513 12.5875 3.00781 12.3004 3.00781 12.0105C3.00781 11.7205 3.06513 11.4334 3.17646 11.1657C3.2878 10.898 3.45096 10.6549 3.65655 10.4505L4.35655 9.75046C4.76616 9.33855 4.99622 8.78136 4.99655 8.20046V7.20046Z",
    stroke: "#333333",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2004_259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitIcon);
export default __webpack_public_path__ + "static/media/profit-icon.1abaa47d7bce47be4223e36bd7d4e66e.svg";
export { ForwardRef as ReactComponent };